// BEE-21: Bottom CTA — forest-green gradient card with decorative arc
import type { CSSProperties } from 'react'
import { Link } from 'react-router-dom'

const CARD_BG: CSSProperties = {
  background: [
    'radial-gradient(130% 110% at 0% 0%, rgba(255,255,255,.12) 0%, transparent 50%)',
    'linear-gradient(120deg, #2d5a3d 0%, #1f4029 100%)',
  ].join(', '),
}

const FOCUS_RING =
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-500 focus-visible:ring-offset-2 focus-visible:ring-offset-[#1f4029]'

export default function BottomCTA() {
  return (
    <section className="py-16 px-6">
      <div className="max-w-[600px] mx-auto">
        <div
          style={CARD_BG}
          className="rounded-[24px] px-12 py-14 text-center relative overflow-hidden"
        >
          {/* Decorative arc — purely visual, hidden from assistive tech */}
          <div
            aria-hidden="true"
            className="absolute right-[-52px] top-[-52px] w-[210px] h-[210px] border-[14px] border-[rgba(200,155,60,.18)] rounded-full pointer-events-none"
          />

          {/* Content sits above the arc via z-index */}
          <div className="relative z-10">
            <h2 className="font-serif font-semibold text-[34px] text-white leading-[1.15] tracking-[-0.01em] mb-3">
              You don&apos;t have to do this alone.
            </h2>
            <p className="font-sans font-normal text-[15px] text-[#b8d0bf] leading-relaxed mb-8 max-w-[420px] mx-auto">
              Create your canopy, invite your village, and bring your community together.
              It&apos;s free to start and takes less than 5 minutes.
            </p>
            <Link
              to="/enroll"
              className={`inline-flex items-center px-7 py-[13px] rounded-full bg-[#c89b3c] text-[#2a1f08] font-sans font-semibold text-[15px] hover:bg-[#b88a2c] transition-colors duration-150 shadow-md ${FOCUS_RING}`}
            >
              Create your canopy &mdash; free
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
